import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GroupWaitingComponent } from './group-waiting.component';
import { SimpleSelectModule } from '../simple-select/simple-select.module';
import { GroupMembersModule } from '../group-members/group-members.module';



@NgModule({
    declarations: [
        GroupWaitingComponent
    ],
    imports: [
        CommonModule,
        SimpleSelectModule,
        GroupMembersModule
    ],
    exports: [
        GroupWaitingComponent
    ]
})
export class GroupWaitingModule { }
